import { render } from "./CourseSelectionPage.vue?vue&type=template&id=2f263374&scoped=true"
import script from "./CourseSelectionPage.vue?vue&type=script&lang=js"
export * from "./CourseSelectionPage.vue?vue&type=script&lang=js"

import "./CourseSelectionPage.vue?vue&type=style&index=0&id=2f263374&scoped=true&lang=css"
import "./CourseSelectionPage.vue?vue&type=style&index=1&id=2f263374&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f263374"]])

export default __exports__